import {ArchiveIcon, LockIcon, type OcticonProps, RepoForkedIcon, RepoIcon} from '@primer/octicons-react'

import type {ExtendedRepository} from '../../../api/common-contracts'

interface RepositoryIconProps extends Omit<OcticonProps, 'icon' | 'aria-label'> {
  repository: ExtendedRepository
}

export const RepositoryIcon: React.FC<RepositoryIconProps> = ({repository, ...props}) =>
  repository.isArchived ? (
    <ArchiveIcon aria-label="Archived repository" {...props} />
  ) : repository.isForked ? (
    <RepoForkedIcon aria-label="Forked repository" {...props} />
  ) : repository.isPublic ? (
    <RepoIcon aria-label="Public repository" {...props} />
  ) : (
    <LockIcon aria-label="Private repository" {...props} />
  )
